var React = require('react');

function SubOrganizationsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm4.67.215a7 7 0 1 0-9.092.212L5.9 15.222a4.5 4.5 0 1 0 1.714 1.03l1.678-2.795A6.98 6.98 0 0 0 12 14a6.973 6.973 0 0 0 3.004-.675l1.625 2.71a4.5 4.5 0 1 0 1.79-.904l-1.749-2.916zM4.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM22 19.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z","fill":"#fff"}));
}

SubOrganizationsIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SubOrganizationsIcon;

SubOrganizationsIcon.default = SubOrganizationsIcon;
